module.exports = __webpack_public_path__ + "img/contact.b37be170.png";